const types = {
  selectOffice: '[Office] Select Office',
  selectEstado: '[Estado] Select Estado',
  addTocart: '[Cart] Add to Cart',
  getCart: '[Cart] Get Cart',
  setShippingAddress: '[Shipping] Set Shipping Address',
  setOrderId: '[Order] Set Order Id',
  referralFromUrl: '[Referral] Set Referal from URL',
  shippingCost: '[Cart] Shipping Cost',
};
export default types;
